import {createFeatureSelector, createSelector} from "@ngrx/store";
import {
  TechInventoryPageMissionState,
  TechInventoryPageState,
  TechInventoryState
} from "@tech/pages/inventory/store/tech-inventory.state";
import {MissionDto, StereotypeListDto} from "@server-models";

export const techInventoryStoreSelect = createFeatureSelector<TechInventoryState>('techInventory');

export const selectTechInventoryPage = createSelector(
  techInventoryStoreSelect,
  (state: TechInventoryState) => state.page
);

// mission
export const selectTechInventoryPageMission = createSelector(
  selectTechInventoryPage,
  (state: TechInventoryPageState) => state.mission
);

export const selectTechInventoryPageMissionList = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.items
);

export const selectTechInventoryPageMissionStereotypes = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.stereotypes
);

// detail
export const selectTechInventoryPageMissionDetail = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.detail
);

export const selectTechInventoryPageMissionDetailMissionId = createSelector(
  selectTechInventoryPageMissionDetail,
  (state: MissionDto | undefined) => state?.missionId
);

export const selectTechInventoryPageMissionDetailReportId = createSelector(
  selectTechInventoryPageMissionDetail,
  (state: MissionDto | undefined) => state?.reportId
);

export const selectTechInventoryPageMissionPagination = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.paging
);

export const selectTechInventoryPageRequested = createSelector(
  selectTechInventoryPage,
  state => state.requested
);

export const selectTechInventoryPageRequestedPagination = createSelector(
  selectTechInventoryPageRequested,
  state => state.paging
);

export const selectTechInventoryPageMissionChangeStateCurrent = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.changeState.current
);

export const selectTechInventoryPageMissionChangeStateLoading = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.changeState.isLoading
);

export const selectTechInventoryPageMissionLoading = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.isLoading
);

export const selectTechInventoryPageMissionLoadingId = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.isLoadingId
);

// report
export const selectTechInventoryPageMissionReport = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.report
);

export const selectTechInventoryPageMissionReportIsLoading = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.report.isLoading
);

export const selectTechInventoryPageMissionReportData = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.report.data
);

export const selectTechInventoryPageMissionReportPreviewCost = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.report.previewCost
);

export const selectTechInventoryPageMissionReportIsSubmitLoading = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.report.isSubmitLoading
);

export const selectTechInventoryPageMissionReportArticlesToAdd = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.report.articlesToAdd
);

export const selectTechInventoryPageMissionReportArticlesToAddData = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.report.articlesToAdd.data
);

export const selectTechInventoryPageMissionReportArticlesToAddIsLoading = createSelector(
  selectTechInventoryPageMission,
  (state: TechInventoryPageMissionState) => state.report.articlesToAdd.isLoading
);

// resource
export const selectTechInventoryPageResource = createSelector(
  selectTechInventoryPage,
  (state: TechInventoryPageState) => state.resource
);

export const selectTechInventoryPageResourceLoading = createSelector(
  selectTechInventoryPageResource,
  (state) => state.isLoading
);

export const selectTechInventoryGoogleAPILoaded = createSelector(
  selectTechInventoryPage,
  (state: TechInventoryPageState) => state.mission.isGoogleAPILoaded
);

export const selectArticleRestrictions = createSelector(
  selectTechInventoryPage,
  (state: TechInventoryPageState) => state.mission.report.articleRestrictions
);

export const selectLastScrollTop = createSelector(
  selectTechInventoryPage,
  (state: TechInventoryPageState) => state.mission.lastScrollTop
);

export const selectTodayDate = createSelector(
  selectTechInventoryPageMission,
  state => state.todayDate
);

export const selectTodayScrollTop = createSelector(
  selectTechInventoryPageMission,
  state => state.todayScrollTop
);
